import React from 'react';
import TextField from 'material-ui/TextField';
import {green500, white} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';
import RaisedButton from 'material-ui/RaisedButton';

import Divider from 'material-ui/Divider';

const style = {
  form: {
    marginLeft: 10,
    marginRight: 10
  },
  box: {
    backgroundColor: '#fff',
    transition: 'none',
    border: 'none',
    borderRadius: '5px',
    position: 'relative',
    marginBottom: '24px',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)',
    overflow: 'hidden'
  },
  button: {
    marginTop: 12,
    marginBottom: 12,
    marginRight: 12,
    float: 'right'
  },
  header: {
    fontSize: 18,
    marginTop: 20,
    fontWeight: typography.fontWeightLight
  }
};

const TipForm = (props) =>{
  let {handleChange, handleSubmit, isLoading} = props;
  let {
    tip_title, url
  } = props.state;

  return (
    <div style={style.box}>
    <form style={style.form} onSubmit={handleSubmit}>

      <div style={style.header}>Create Tip</div>
      
      <TextField
        hintText="Tip Title"
        floatingLabelText="Title"
        underlineShow={false}
        required={true}
        value={tip_title}
        onChange={handleChange.bind(null, 'tip_title')}
      />
      <Divider />
      <TextField
        hintText="URL"
        floatingLabelText="URL"
        underlineShow={false}
        required={true}
        value={url}
        onChange={handleChange.bind(null, 'url')}
      />
      <Divider />
      
      <div style={style.button}>
        <RaisedButton
          label="Submit"
          type="submit"
          backgroundColor={green500}
          labelColor={white}
          disabled={isLoading}
        />
      </div>
    </form>
    </div>
  )
}

export default TipForm;




// WEBPACK FOOTER //
// ./src/screens/shared/tip-form.js